import { ProductTypeConfig, DEFAULT_SECTIONS } from '../types';

/**
 * 2110 - Spread Warrant
 */
export const config2110: ProductTypeConfig = {
  code: '2110',
  name: 'Spread Warrant',
  sections: {
    ...DEFAULT_SECTIONS,
    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: false,
        premium: true,
        quotationType: true,
        lowerStrike: true,
        basketOptionType: true,
        settlementType: true,
        upperStrike: true,
      },
    },
    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: false,
    },
    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        ...DEFAULT_SECTIONS.underlyings.props,
        barrierLevel: false,
        barrierDistance: false,
        upperStrike: true,
      },
    },
    couponDetails: {
        ...DEFAULT_SECTIONS.couponDetails,
        enabled: true,
    },
  },
};
